import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  __name: 'TopLearning',
  setup: function setup(__props) {
    var DdButton = function DdButton() {
      return import('~/components/DdButton.vue');
    };
    var PanelButton = function PanelButton() {
      return import('~/components/panels/PanelButton.vue');
    };
    var ActiveCourses = function ActiveCourses() {
      return import('~/components/dropdowns/ActiveCourses.vue');
    };
    var authPanelStore = useAuthPanelStore();
    var cookieStore = useCookieStore();
    var saleStore = useSaleStore();
    var $route = useRoute();
    var timeStore = useTimeStore();
    var _useNuxtApp = useNuxtApp(),
      $scrollTo = _useNuxtApp.$scrollTo,
      $auth = _useNuxtApp.$auth;
    var isUkrainian = computed(function () {
      return cookieStore.isUkrainian;
    });
    function login() {
      this.authPanelStore.$patch({
        direction: 'right',
        state: 'login'
      });
    }
    function scrollTop(path) {
      if ($route.path == path) $scrollTo('body');
    }
    var subscriptionStore = useSubscriptionStore();
    onMounted(function () {
      if (!subscriptionStore.hydrated && $auth.user) subscriptionStore.hydrate();
    });
    var token = computed(function () {
      var token = subscriptionStore.token;
      if (token && token.end) {
        var end = new Date(token.end);
        if (end < timeStore.now) token = null;
      }
      return token;
    });
    var tokenEnd = computed(function () {
      if (!token.value || !token.value.end) return false;
      return new Date(token.value.end);
    });
    var tokenExpired = computed(function () {
      if (!token.value) return true;
      if (!tokenEnd.value) return false;
      return tokenEnd.value < timeStore.now;
    });
    var subscriptionState = computed(function () {
      if (!subscriptionStore.hydrated || !$auth.user) return null;
      if (subscriptionStore.trialVisible) {
        return 'tryTrial';
      }
      if (!token.value && !subscriptionStore.hadAccess && !subscriptionStore.trialAvailable) {
        return 'trialOver';
      }
      if (subscriptionStore.hadAccess && tokenExpired.value) {
        return 'accessOver';
      }
      return 'active';
    });
    return {
      __sfc: true,
      DdButton: DdButton,
      PanelButton: PanelButton,
      ActiveCourses: ActiveCourses,
      authPanelStore: authPanelStore,
      cookieStore: cookieStore,
      saleStore: saleStore,
      $route: $route,
      timeStore: timeStore,
      $scrollTo: $scrollTo,
      $auth: $auth,
      isUkrainian: isUkrainian,
      login: login,
      scrollTop: scrollTop,
      subscriptionStore: subscriptionStore,
      token: token,
      tokenEnd: tokenEnd,
      tokenExpired: tokenExpired,
      subscriptionState: subscriptionState
    };
  }
};